/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

$(document).ready(function () {
  if ($(".pagination").length) {
    var fniv = $(".pagination .prev").next("span").find("a").attr("href");

    if (fniv && fniv.indexOf("?page=1") >= 0) {
      var newval = fniv.replace('?page=1', '');
      $(".pagination .prev").next("span").find("a").attr("href", newval);
    }

    if ($(".pagination .prev").length) {
      if ($(".pagination .prev a").attr("href").indexOf("?page=1") >= 0) {
        var _newval = fniv.replace('?page=1', '');

        $(".pagination .prev a").attr("href", _newval);
      }
    }
  }

  $(document).on('click', '.variant__label-info', function () {
    $(this).toggleClass('is-active');
    $(this).parent().closest('.wrapper-option').children('.variant-input-wrap').slideToggle(100);
  });
  window.addEventListener('pplrAddToCartCompleted', function (e) {
    // check if the add to cart event has fired
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();
  });
});
$(document).ready(function () {
  var request = new XMLHttpRequest();
  request.open("GET", "https://api.reviews.io/timeline/data?type=store_review&store=www.identim.de&sort=date_desc&page=1&per_page=1&enable_avatars=false&include_subrating_breakdown=1&branch=&tag=&v=202272515&minRating=4&include_product_reviews=1&include_local_reviews=1");
  request.send();

  request.onload = function () {
    if (request.status === 200) {
      var stats = JSON.parse(request.response)["stats"];
      var total_reviews = stats["review_count"];
      var average_third_party_rating = stats["average_rating"];
      var number_average_third_party_rating = Number(average_third_party_rating).toFixed(1);
      $(".js-reviewCounterHeader").text(total_reviews);
      $(".js-reviewStarHeader").text(number_average_third_party_rating + "/5.0");
      $('.reviews_calculated').addClass('visiblebanner');
      var reviewsio_carousel_find = false;
      var reviewsio_badge_find = false;
      var AdjustCount = setInterval(function () {
        if (!reviewsio_carousel_find) {
          $("#reviewsio-carousel-widget").find(".cssVar-subheading__number").first().text(number_average_third_party_rating + " ");
          $("#reviewsio-carousel-widget").find(".cssVar-subheading__number").last().text(total_reviews + " ");
          reviewsio_carousel_find = true;
        } // if(!reviewsio_badge_find){
        //   //  $("#floatingWidget-defaultContainer").
        //    $(".number__big").first().text(Number(average_third_party_rating).toFixed(2));
        //   reviewsio_badge_find=true;
        // }

      }, 500);

      if (reviewsio_carousel_find) {
        clearInterval(AdjustCount);
      }
    } else {
      console.log("bad request");
    }
  };
});

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkidentim"] = self["webpackChunkidentim"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;

// custom variant selection js
$(document).ready(function(){
  $(document).on('click', '.variant-input input', function(){
    if($(this).parents('.wrapper-option').find('.variant__label .variant__label-info').hasClass('is-active')){
      var inpuValue = $(this).next().html();    
      $(this).parents('.variant-input-wrap').slideUp(100);
      $(this).parents('.wrapper-option').find('.variant__label .customvariantselected').html(inpuValue);
      $(this).parents('.wrapper-option').find('.variant__label .variant__label-info').removeClass('is-active');
    }
    if(!($(this).hasClass('disabled'))){
      $('.submit__wrapper .add-to-cart').removeAttr('disabled');
    }
  })
});
